import {
  createEntityAdapter,
  createSlice,
  PayloadAction
} from '@reduxjs/toolkit'
import { normalize } from 'normalizr'
import { IFilterProfileLite } from '$/types'

import {
  filterProfileSchema,
  IFilterProfileNormalizedEntities
} from 'app/entities/schema/filterProfileSchema'
import { setStagingProfileFulfilledSync } from 'app/layout/Navbar/Filters/globalFilterSlice'

/**
 * NOTE: We are using "lite" version of filter profile interface here
 *       due to no guarantee of it being the full object, as the
 *       filter profile list API returns the "lite" version of it.
 *
 * WARN: Cast to full filter profile interface at your own discretion
 */

export const filterProfilesAdapter = createEntityAdapter<
  IFilterProfileLite,
  string
>({
  selectId: (filterProfile) => filterProfile.id.toString()
})

const filterProfilesSlice = createSlice({
  name: 'filterProfiles',
  initialState: filterProfilesAdapter.getInitialState(),
  reducers: {
    deleteFilterProfile(state, action: PayloadAction<string>) {
      filterProfilesAdapter.removeOne(state, action.payload)
    },
    setFilterProfileList(state, action: PayloadAction<IFilterProfileLite[]>) {
      const normalized = normalize<
        IFilterProfileLite[],
        IFilterProfileNormalizedEntities
      >(action.payload, [filterProfileSchema])

      filterProfilesAdapter.setAll(
        state,
        normalized.entities.filterProfiles ?? []
      )
    }
  },
  extraReducers: (builder) => {
    builder.addCase(
      setStagingProfileFulfilledSync,
      (state, action: PayloadAction<IFilterProfileLite | undefined>) => {
        const normalized = normalize<
          IFilterProfileLite,
          IFilterProfileNormalizedEntities
        >(action.payload, filterProfileSchema)

        filterProfilesAdapter.upsertMany(
          state,
          normalized.entities.filterProfiles
        )
      }
    )
  }
})

export default filterProfilesSlice.reducer

export const {
  deleteFilterProfile: deleteFilterProfileSync,
  setFilterProfileList: setFilterProfileListSync
} = filterProfilesSlice.actions
